import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { showNotification } from '@mantine/notifications';
import { QUERY_KEYS } from '@/constants/queryKeys';
import { churchesService } from '@/services/churches.service';

export const useChurchGroupListAdmins = (churchId: string | undefined) => {
  return useQuery({
    queryKey: [QUERY_KEYS.CHURCH_GROUP_LIST_ADMINS, churchId],
    queryFn: () => churchesService.getChurchGroupListAdmins(churchId ?? ''),
    enabled: !!churchId,
  });
};

export const useRemoveChurchGroupListAdminGroupMutation = (churchId: string) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ userId, groupId }: { userId: string; groupId: string }) =>
      churchesService.removeChurchGroupListAdminGroup(churchId, userId, groupId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.CHURCH_GROUP_LIST_ADMINS, churchId] });
      showNotification({ title: 'Success', message: 'Group access removed successfully', color: 'green' });
    },
  });
};

export const useRemoveChurchGroupListAdminListMutation = (churchId: string) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ userId, listId }: { userId: string; listId: string }) =>
      churchesService.removeChurchGroupListAdminList(churchId, userId, listId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.CHURCH_GROUP_LIST_ADMINS, churchId] });
      showNotification({ title: 'Success', message: 'List access removed successfully', color: 'green' });
    },
  });
};
